import Integration from "../integration/Integrations";
import { pathMatches } from "../util/pathMatches";
import { Tag } from "./Tag";
import { maXCheckoutApplicationProductEventsTag } from "./maXCheckoutApplicationProductEventsTag";
var eventData = function () {
    return {
        origin: getOrigin()
    };
};
var getOrigin = function () {
    var referrer = document.referrer;
    if (referrer && referrer.includes("/max/branchquotes/")) {
        return "branch_quotes";
    }
    else if (referrer && referrer.includes("/max/customerquotes/")) {
        return "my_quotes";
    }
    else if (referrer && referrer.includes("/max/productlists/")) {
        return "product_list";
    }
    else if (referrer && referrer.includes("/search/")) {
        return "product_search";
    }
    else if (referrer && referrer.includes("/product/")) {
        return "product_details_page";
    }
    return null;
};
var pushNavigationEventFor = function (targetPath) {
    if (pathMatches(targetPath, "^/max/checkout/$")) {
        Integration.submitAnalyticEvent({
            eventName: "viewCheckoutCartPage",
            eventData: eventData(),
            page: targetPath
        }).catch(function (reason) { return console.warn("Analytic event submission failed with reason [".concat(reason, "]")); });
    }
    else if (pathMatches(targetPath, "^/max/checkout/order$")) {
        Integration.submitAnalyticEvent({
            eventName: "viewCheckoutFulfilmentPage",
            eventData: eventData(),
            page: targetPath
        }).catch(function (reason) { return console.warn("Analytic event submission failed with reason [".concat(reason, "]")); });
    }
};
export var maXCheckoutApplicationViewEventsTag = new Tag(function () {
    // push event for initial page load
    pushNavigationEventFor(document.location.pathname);
    if (pathMatches(document.location.pathname, "^/max/checkout/.*$")) {
        maXCheckoutApplicationProductEventsTag.executeSafely();
    }
    window.addEventListener("maxlocationchange", function (e) {
        var _a;
        var targetUrl = (_a = e.detail.targetUrl) === null || _a === void 0 ? void 0 : _a.pathname;
        if (targetUrl)
            pushNavigationEventFor(targetUrl);
    });
});
